import { render, staticRenderFns } from "./hongbao.vue?vue&type=template&id=10775158&scoped=true&"
import script from "./hongbao.vue?vue&type=script&lang=js&"
export * from "./hongbao.vue?vue&type=script&lang=js&"
import style0 from "./hongbao.vue?vue&type=style&index=0&id=10775158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10775158",
  null
  
)

export default component.exports